import script from "./news-letter-one.vue?vue&type=script&setup=true&lang=js"
export * from "./news-letter-one.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__